import React, { FC } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Result } from "antd";

import { brand } from "../../theme/brands";

interface Props {}

const ThankYou: FC<Props> = (props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cancelled = searchParams.get("cancelled") === "true";
  const bookingRef = searchParams.get("ref");

  if (cancelled) {
    return (
      <div className="max-w-xl mx-auto px-4 my-8 md:my-12">
        <Result
          className="bg-white rounded-2xl shadow-sm"
          status="error"
          title="Payment Failed or Cancelled!"
          subTitle={
            <>
              Please retry registration. If the problem persists, please contact us on our FB Events Page or email (
              <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>).
            </>
          }
          extra={[
            <Button type="primary" key="console" onClick={() => navigate("/")}>
              Go to Events
            </Button>,
          ]}
        />
      </div>
    );
  } else {
    return (
      <div className="max-w-xl mx-auto px-4 my-8 md:my-12">
        <Result
          className="bg-white rounded-2xl shadow-sm"
          status="success"
          title="Thank you for registering!"
          subTitle={
            <>
              Your registration has been received and payment is being processed. You should be receiving an email
              confirmation. Please follow our FB Events Page for any updates. We will be sending a final email with all
              the details a few days before the event.
              {bookingRef && (
                <div className="mt-3 text-base">
                  Your booking reference: <b>{bookingRef}</b> — quote this in any correspondence.
                </div>
              )}
            </>
          }
          extra={[
            <Button type="primary" key="console" onClick={() => navigate("/")}>
              Back to Events
            </Button>,
          ]}
        />
      </div>
    );
  }
};

export default ThankYou;
